module.exports = "https://trybtryb-legacy.web.app/img/eye-closed.10e33fc5.svg";